import React from 'react';
import SelectSymbol from '../../../components/SelectSymbol/SelectSymbol';
import SwitchInput from '../../../components/SwitchInput/SwitchInput';
import ConditionsArea from './ConditionsArea/ConditionsArea';
import ActionsArea from './ActionsArea/ActionsArea';
import ScheduleArea from './ScheduleArea/ScheduleArea';
import LogView from '../../../components/Logs/LogView';
import MaxOpenPositionsField from '../MaxOpenPositionsField';

/**
 * props:
 * - automation
 * - indexes
 * - showLogs
 * - onInputChange
 * - symbolLabel
 * - namePlaceholder
 */
function AutomationFormFields(props) {
    const {
        automation,
        indexes,
        showLogs,
        onInputChange,
        symbolLabel = 'Symbol:',
        namePlaceholder = 'My automation name',
    } = props;

    if (showLogs) {
        return <LogView file={`A:${automation.id}`} />;
    }

    return (
        <>
            <div className="row">
                <div className="col-md-7 mb-3">
                    <div className="form-group">
                        <label htmlFor="symbol">{symbolLabel}</label>
                        <SelectSymbol
                            onChange={onInputChange}
                            symbol={automation.symbol}
                            disabled={automation.id > 0}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 mb-3">
                    <div className="form-group">
                        <label htmlFor="name">Name:</label>
                        <input
                            className="form-control"
                            id="name"
                            type="text"
                            placeholder={namePlaceholder}
                            value={automation.name || ''}
                            required
                            onChange={onInputChange}
                        />
                    </div>
                </div>
            </div>

            {automation.schedule ? (
                <ScheduleArea schedule={automation.schedule} onChange={onInputChange} />
            ) : null}

            <ul className="nav nav-tabs" id="tabs" role="tablist">
                <li className="nav-item" role="presentation">
                    <button
                        className="nav-link active"
                        id="conditions-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#conditions"
                        type="button"
                        role="tab"
                        aria-controls="conditions"
                        aria-selected="true"
                    >
                        Conditions
                    </button>
                </li>
                <li className="nav-item" role="presentation">
                    <button
                        className="nav-link"
                        id="actions-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#actions"
                        type="button"
                        role="tab"
                        aria-controls="actions"
                        aria-selected="false"
                    >
                        Actions
                    </button>
                </li>
            </ul>
            <div className="tab-content px-3 mb-3" id="tabContent">
                <div className="tab-pane fade show active pt-3" id="conditions" role="tabpanel" aria-labelledby="conditions-tab">
                    <ConditionsArea
                        symbol={automation.symbol}
                        conditions={automation.conditions}
                        indexes={indexes}
                        onChange={onInputChange}
                    />
                </div>
                <div className="tab-pane fade" id="actions" role="tabpanel" aria-labelledby="actions-tab">
                    <ActionsArea symbol={automation.symbol} actions={automation.actions} onChange={onInputChange} />
                </div>
            </div>

            <MaxOpenPositionsField
                value={automation.maxOpenPositions}
                onChange={onInputChange}
            />

            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <SwitchInput id="isActive" text="Is Active?" onChange={onInputChange} isChecked={automation.isActive} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <SwitchInput id="logs" text="Enable Logs?" onChange={onInputChange} isChecked={automation.logs} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default AutomationFormFields;